import React from 'react';
import { Line } from 'react-konva';

const DashedLine = ({ x1, y1, x2, y2 }) => (
  <Line
    points={[x1, y1, x2, y2]}
    stroke="#00a0e6"  // Màu của đường nét đứt
    strokeWidth={2}
    dash={[10, 5]}  // Kiểu nét đứt (dài 10, ngắt 5)
    tension={0}
  />
);

export default DashedLine;